import { useEffect, useState } from 'react';

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={handleClick}
      aria-label="Zurück nach oben"
      className="fixed bottom-8 right-8 z-50 w-11 h-11 flex items-center justify-center bg-[#1E3A8A] hover:bg-[#1e40af] text-white rounded-full cursor-pointer transition-all duration-300 whitespace-nowrap"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0) scale(1)' : 'translateY(16px) scale(0.85)',
        pointerEvents: visible ? 'auto' : 'none',
        boxShadow: '0 4px 16px rgba(30,58,138,0.25)',
      }}
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
};

export default ScrollToTop;
